export const getImageUrlCategories = (position: string): string => {
  switch (position) {
    case 'center1':
      return 'https://i.factcool.com/valentine/banners/banner_desktop_woman.jpg'

    case 'center2':
      return 'https://i.factcool.com/valentine/banners/banner_desktop_men.jpg'

    case 'center3':
      return 'https://i.factcool.com/valentine/banners/banner_desktop_kids.jpg'

    case 'center4':
      return 'https://i.factcool.com/valentine/banners/banner_desktop_animal.jpg'

    case 'center5':
      return 'https://i.factcool.com/valentine/banners/banner_desktop_frogies.jpg'

    case 'center6':
      return 'https://i.factcool.com/valentine/banners/banner_desktop_collection.jpg'
    default:
      return null
  }
}

export const getImageUrlSubcategories = (
  sort: number,
  position: string
): string => {
  switch (position) {
    case 'center1':
      switch (sort) {
        case 0:
          return 'https://i.factcool.com/valentine/products/woman/1.jpg'
        case 1:
          return 'https://i.factcool.com/valentine/products/woman/2.jpg'
        case 2:
          return 'https://i.factcool.com/valentine/products/woman/3.jpg'
        case 3:
          return 'https://i.factcool.com/valentine/products/woman/4.jpg'
        case 4:
          return 'https://i.factcool.com/valentine/products/woman/5.jpg'
        case 5:
          return 'https://i.factcool.com/valentine/products/woman/6.jpg'
        case 6:
          return 'https://i.factcool.com/valentine/products/woman/7.jpg'
        case 7:
          return 'https://i.factcool.com/valentine/products/woman/8.jpg'
        default:
          return 'null'
      }

    case 'center2':
      switch (sort) {
        case 0:
          return 'https://i.factcool.com/valentine/products/men/1.jpg'
        case 1:
          return 'https://i.factcool.com/valentine/products/men/2.jpg'
        case 2:
          return 'https://i.factcool.com/valentine/products/men/3.jpg'
        case 3:
          return 'https://i.factcool.com/valentine/products/men/4.jpg'
        case 4:
          return 'https://i.factcool.com/valentine/products/men/5.jpg'
        case 5:
          return 'https://i.factcool.com/valentine/products/men/6.jpg'
        case 6:
          return 'https://i.factcool.com/valentine/products/men/7.jpg'
        case 7:
          return 'https://i.factcool.com/valentine/products/men/8.jpg'
        default:
          return null
      }

    case 'center3':
      switch (sort) {
        case 0:
          return 'https://i.factcool.com/valentine/products/kids/1.jpg'
        case 1:
          return 'https://i.factcool.com/valentine/products/kids/2.jpg'
        case 2:
          return 'https://i.factcool.com/valentine/products/kids/3.jpg'
        case 3:
          return 'https://i.factcool.com/valentine/products/kids/4.jpg'
        case 4:
          return 'https://i.factcool.com/valentine/products/kids/5.jpg'
        case 5:
          return 'https://i.factcool.com/valentine/products/kids/6.jpg'
        case 6:
          return 'https://i.factcool.com/valentine/products/kids/7.jpg'
        case 7:
          return 'https://i.factcool.com/valentine/products/kids/8.jpg'
        default:
          return null
      }

    case 'center4':
      switch (sort) {
        case 0:
          return 'https://i.factcool.com/valentine/products/animals/1.jpg'
        case 1:
          return 'https://i.factcool.com/valentine/products/animals/2.jpg'
        case 2:
          return 'https://i.factcool.com/valentine/products/animals/3.jpg'
        case 3:
          return 'https://i.factcool.com/valentine/products/animals/4.jpg'
        default:
          return null
      }
  }
}
